import {UserCreate, UserResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class UserApi extends CrudApiAbstract<UserResource, UserCreate> {
  public constructor() {
    super(`${ResourceType.User}s`);
  }
}
